// extracted by css-extract-rspack-plugin
export default {"segmentedControl":"segmented-control-module__segmentedControl__BZ8f_6N","active":"segmented-control-module__active__ZTdlSUu"};